import React from 'react';
import { BuildingIcon, ClipboardListIcon, LayoutDashboardIcon, UsersIcon, WalletIcon, WrenchIcon } from 'lucide-react';
import { OperatorShell } from './OperatorShell';
import type { NavGroup } from './OperatorShell';
import { Meter } from '../ui/Meter';
import { managedProperties } from '../../data/property';
import { percent } from '../../utils/format';

/**
 * Every section has its own address, so refresh, back and a link pasted to a
 * colleague all land where the operator expects.
 */
const GROUPS: NavGroup[] = [{
  label: 'Portfolio',
  items: [{
    to: '/property',
    label: 'Occupancy overview',
    icon: LayoutDashboardIcon,
    end: true
  }, {
    to: '/property/inventory',
    label: 'Inventory',
    icon: BuildingIcon
  }]
}, {
  label: 'Letting',
  items: [{
    to: '/property/applications',
    label: 'Applications',
    icon: ClipboardListIcon
  }, {
    to: '/property/tenants',
    label: 'Tenants',
    icon: UsersIcon
  }]
}, {
  label: 'Operations',
  items: [{
    to: '/property/rent',
    label: 'Rent ledger',
    icon: WalletIcon
  }, {
    to: '/property/maintenance',
    label: 'Maintenance',
    icon: WrenchIcon
  }]
}];
export function PropertyShell() {
  const beds = managedProperties.flatMap(property => property.buildings.flatMap(building => building.rooms.flatMap(room => room.beds)));
  const occupied = beds.filter(bed => bed.status === 'occupied').length;
  return <OperatorShell consoleKey="property" consoleName="Property console" scopeLine="Cedarwood Living · 3 properties in Lagos" groups={GROUPS} summary={<div data-id="element-5287" data-mp="m1jgmbf60dx8">
          <Meter label="Portfolio occupancy" trailing={`${percent(occupied, beds.length)}%`} value={percent(occupied, beds.length)} data-id="element-5288" data-mp="m22zpvgjx8cu" />
          <p className="cz-num mt-2 text-caption text-ink-muted" data-id="element-5289" data-mp="36rsek8h98u5j">
            {occupied} of {beds.length} beds let · {beds.length - occupied} available
          </p>
        </div>} data-id="element-5286" data-mp="w1ab4d3q6sxb" />;
}